module.exports = __webpack_public_path__ + "img/icon-bookmark.90e249ac.svg";